import Image from "next/image";
import { ShowWhen } from "../show-when/show-when";
import { OptionType } from "./select";
import classNames from "classnames";
import { useTranslations } from "next-intl";

const SelectOptionButton = ({
  option,
  selectedOption,
  handleSelect,
  iconFit,
  translation = false,
}: {
  option: OptionType;
  selectedOption?: OptionType;
  handleSelect: (option: any) => void;
  iconFit?: "cover" | "contain" | "scale-down";
  translation?: boolean;
}) => {
  const t = useTranslations();

  return (
    <li
      className={classNames(
        "transition-500 mx-[10px] rounded-[5px] transition-all",
        selectedOption?.id === option?.id
          ? option?.img
            ? "bg-[#f9f9f9] font-medium"
            : "font-bold"
          : "font-medium",
        option?.img
          ? "px-[4px] py-[6px] hover:bg-[#f9f9f9]"
          : "border-b-[1px] border-[#F6F6F6] pb-[10px] pt-[14px] hover:font-bold",
      )}
    >
      <button
        onMouseDown={(e) => {
          // Prevent focus shifts and stop global mousedown outside-click handlers
          e.preventDefault();
          e.stopPropagation();
          // Also stop native listener propagation
          (e as any).nativeEvent?.stopImmediatePropagation?.();
          handleSelect(option);
        }}
        className="flex w-full items-center"
        type="button"
      >
        <ShowWhen
          condition={!!option.img}
          elseRender={
            <ShowWhen condition={!!option.icon}>
              <div className="mr-[8px] flex h-[46px] w-[46px] items-center justify-center overflow-hidden rounded-full">
                <div
                  className={`black-color flex h-full w-full items-center justify-center bg-[#F9F9F9] object-${iconFit || "contain"} `}
                >
                  {option.icon}
                </div>
              </div>
            </ShowWhen>
          }
        >
          <div className="mr-[8px] flex h-[46px] w-[46px] items-center justify-center overflow-hidden rounded-full">
            <Image
              src={option.img}
              alt={option.mainText || " "}
              width={46}
              height={46}
              className={`h-full object-${iconFit}`}
            />
          </div>
        </ShowWhen>
        <div className="flex flex-col items-start gap-[3px]">
          <h2 className={classNames("text-xs capitalize text-black")}>
            {translation ? t(option.mainText) : option.mainText}
          </h2>
          {option.secondaryText && (
            <span className="text-xs font-medium text-neutral-400 opacity-50">
              {translation ? t(option.secondaryText) : option.secondaryText}
            </span>
          )}
        </div>
      </button>
    </li>
  );
};

export { SelectOptionButton };
